<template>
  <div class="map-container">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <LMap
      ref="map"
      :zoom.sync="zoom"
      :options="mapOptions"
      :center="center"
      :bounds="bounds"
      :min-zoom="minZoom"
      :max-zoom="maxZoom"
      @click="clickMap"
    >
      <l-control-zoom position="topright" />

      <LTileLayer :url="url"></LTileLayer>
      <LLayerGroup
        v-if="grouplocations.length > 0"
        layer-type="overlay"
        :visible.sync="devices_visibility"
        :name="$t('devices')"
      >
        <LMarker
          :key="grouplocation.id"
          v-for="grouplocation in grouplocations"
          :lat-lng="[
            grouplocation.stat.latitude,
            grouplocation.stat.longitude,
          ]"
          @click="viewdevice(grouplocation)"
        >
          <l-popup>
            <div class="p-2">
              {{ grouplocation.settings.name }}
              <div>{{ $t("temperature") }}: {{ grouplocation.stat.temperature }}</div>
              <div>{{ $t("humid") }}: {{ grouplocation.stat.humidity }}</div>
            </div>
          </l-popup>
          <l-icon :icon-anchor="[18, 0]">
            <img
              v-if="grouplocation.status == 'critical'"
              src="../../assets/images/marker-critical.svg"
              alt=""
              height="40px"
            />
            <img
              v-else
              src="../../assets/images/marker-good.svg"
              alt=""
              height="40px"
            />
          </l-icon>
        </LMarker>
      </LLayerGroup>
      <LLayerGroup
        layer-type="overlay"
        :visible.sync="POI_visibility"
        name="POI"
      >
        <LMarker
          v-for="(marker, index) in POI"
          :key="index"
          :lat-lng.sync="marker.position"
        >
          <l-popup :content="marker.name" />
          <l-icon :icon-anchor="[18, 0]">
            <img src="../../assets/images/home.svg" alt="" height="40px" />
          </l-icon>
        </LMarker>
      </LLayerGroup>
      <LLayerGroup
        layer-type="overlay"
        :visible.sync="geofence_visibility"
        name="Geo-fence"
      >
        <l-polygon
          :key="index"
          v-for="(polygon, index) in geofence"
          :lat-lngs="polygon.latlngs"
          :color="polygon.color"
        >
          <l-popup :content="polygon.name" />
        </l-polygon>
      </LLayerGroup>
      <!-- <LControlLayers
        position="topright"
        :collapsed="false"
        :sort-layers="true"
      /> -->

      <l-control class="control-layer">
        <!-- <div class="tools tools-show"> -->
        <div class="d-flex align-items-center py-1">
          <input
            type="checkbox"
            name="devices_show"
            id="devices_show"
            @change="devices_visibility = !devices_visibility"
            :checked="devices_visibility"
            class="mr-2"
          />
          {{ $t('devices') }}
        </div>
        <div class="d-flex align-items-center py-1">
          <input
            type="checkbox"
            name="POI_show"
            id="POI_show"
            @change="POI_visibility = !POI_visibility"
            class="mr-2"
            :checked="POI_visibility"
          />
          POI
        </div>
        <div class="d-flex align-items-center py-1">
          <input
            type="checkbox"
            name="geofence_show"
            id="geofence_show"
            @change="geofence_visibility = !geofence_visibility"
            class="mr-2"
            :checked="geofence_visibility"
          />
          {{ $t('geo') }}
        </div>
        <!-- </div> -->
      </l-control>
      <!-- <l-control class="tools-container">
        <div @click="toolsBar = false" v-if="toolsBar" class="mask"></div>

        <div style="padding: 10px; z-index:50" @click="toolsBar = !toolsBar">
          <i class="fas fa-wrench"></i>
        </div>
        <div :class="{ 'tools-show': toolsBar }" class="tools">
          <button @click="showPOI" class="my-2">POI</button>
          <button @click="showGeofence" class="">GeoFence</button>
        </div>
      </l-control> -->
    </LMap>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// import L from "leaflet";
import 'leaflet/dist/leaflet.css';

import {
  LMap,
  LTileLayer,
  LMarker,
  LPolygon,
  LPopup,
  LIcon,
  LControlZoom,
  LControl,
  LLayerGroup,
  // LControlLayers,
} from "vue2-leaflet";
import { latLngBounds } from "leaflet";

export default {
  name: "LiveMap",
  props: {
    group: Object,
    POIname: String,
    addpoi: Boolean,
    POI: Array,
    geofencename: String,
    geofencecolor: String,
    addgeofence: Boolean,
    geofence: Array,
    POIhandler: Boolean,
    geofencehandler: Boolean,
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
    LPopup,
    LIcon,
    LControlZoom,
    LControl,
    LLayerGroup,
    // LControlLayers,
    Loading,
  },
  data() {
    return {
      url: "http://www.google.cn/maps/vt?lyrs=p@189&gl=tr&x={x}&y={y}&z={z}",
      zoom: 12,
      // center: [6.9367826, 3.6711133],
      center: [6.600488319999999, 3.3602678599999996],
      bounds: null,
      // marker: latLng(7.9367826, 3.6711133),
      mapOptions: {
        zoomControl: false,
        attributionControl: false,
        zoomSnap: true,
      },
      minZoom: 4,
      maxZoom: 16,
      isLoading: false,
      fullPage: true,
      toolsBar: false,
      devices_visibility: true,
      POI_visibility: false,
      geofence_visibility: false,
    };
  },
  watch: {
    group: {
      handler: function() {
        this.isLoading = true;
        this.fetchGroupLocations({ group_id: this.group.id })
          .then(() => {
            let totalLat = 0;
            let totalLong = 0;
            let activedevices = 0;
            if (this.grouplocations.length > 0) {
              for (let i = 0; i < this.grouplocations.length; i++) {
                if (
                  this.grouplocations[i].stat.latitude &&
                  this.grouplocations[i].stat.longitude
                ) {
                  // console.log(this.grouplocations[i].stat.latitude, this.grouplocations[i].stat.longitude)
                  activedevices++;
                  totalLat += this.grouplocations[i].stat.latitude;
                  totalLong += this.grouplocations[i].stat.longitude;
                }
              }
              this.center = [
                totalLat / activedevices,
                totalLong / activedevices,
              ];
            }
            // console.log(this.center, "center")
            this.isLoading = false;
          })
          .catch((err) => {
            console.error(err);
            this.isLoading = false;
          });
      },
      deep: true,
    },
    addgeofence: {
      handler: function() {
        if (this.addgeofence) {
          // console.log("geofence created");
          this.geofence.push({
            name: this.geofencename,
            color: this.geofencecolor,
            latlngs: [],
          });
        }
      },
      deep: true,
    },
    POIhandler: {
      handler: function() {
        this.POI_visibility = true;
      },
      deep: true,
    },
    geofencehandler: {
      handler: function() {
        this.geofence_visibility = true;
      },
      deep: true,
    },
  },
  mounted() {
    // console.log("group live map mounted");
    this.fetchGroupLocations({ group_id: this.group.id })
      .then(() => {
        let bounds = [];
        for (let i = 0; i < this.grouplocations.length; i++) {
          bounds.push([
            this.grouplocations[i].stat.latitude,
            this.grouplocations[i].stat.longitude,
          ]);
        }
        if (this.grouplocations.length <= 0) {
          this.bounds = latLngBounds([
            [6.50081290280357, 3.46963806152345],
            [7.02991732677597, 3.38716201782228],
          ]);
        } else {
          this.bounds = latLngBounds(bounds);
        }
        this.isLoading = false;
      })
      .catch((err) => {
        console.error(err);
        this.isLoading = false;
      });
  },
  computed: {
    ...mapGetters(["grouplocations"]),
  },
  methods: {
    ...mapActions(["fetchGroupLocations", "addPOI"]),
    viewdevice(device) {
      setTimeout(() => {
        this.center = [device.stat.latitude, device.stat.longitude];
      }, 600);
    },
    clickMap(e) {
      if (this.addpoi) {
        this.isLoading = true;
        const newMarker = {
          position: { lat: e.latlng.lat, lng: e.latlng.lng },
          name: this.POIname,
          // draggable: true,
        };
        this.addPOI({ POI: newMarker })
          .then(() => {
            this.POI.push(newMarker);
            this.isLoading = false;
            // console.log(this.POI, "poi updated");
            this.$emit("poi-added");
          })
          .catch((err) => console.error(err));
      }
      if (this.addgeofence) {
        // console.log([e.latlng.lat, e.latlng.lng], "lats");
        let index = this.geofence.length - 1;
        this.geofence[index].latlngs.push([e.latlng.lat, e.latlng.lng]);
        this.geofence[index].latlngs.push([e.latlng.lat, e.latlng.lng]);
        if (this.geofence[index].latlngs.length == 1) {
          this.$emit("geofence-firstclick");
        }
        if (this.geofence[index].latlngs.length == 2) {
          this.$emit("geofence-secondclick");
        }
      }
    },
  },
};
</script>

<style scoped>
.map-container {
  height: 100%;
  /* transition: 0.5s ease-in; */
}
.control-layer {
  background: #fff;
  padding: 10px;
  display: flex;
  flex-direction: column;
}
.tools-container {
  position: relative;
  background: #fff;
  /* padding: 10px; */
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.tools {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 100%;
  right: 0;
  margin-top: 10px;
  height: 0;
  overflow: hidden;
  transition: 0.3s ease-out;
  padding: 0 10px;
  background: black;
}
.tools-show {
  height: 80px;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  background: transparent;
  height: 100vh;
  width: 100vw;
  cursor: default;
}
</style>
